const { TYPES } = require("./dialog_edited.type");

const initState = {
  dialogEdited: null,
  dialogEditedSpeakers: null,
  dialogEditedComments: null,
};

const dialogEditedReducer = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case TYPES.SET_DIALOG_EDITED_ALL:
      return { ...state, dialogEdited: payload };
    case TYPES.SET_DIALOG_EDITED_SPEAKERS:
      return { ...state, dialogEditedSpeakers: payload };
    case TYPES.SET_DIALOG_EDITED_COMMENTS:
      return { ...state, dialogEditedComments: payload };
    default:
      return state;
  }
};

export default dialogEditedReducer;
